import { defaultI18nEn } from './global.en';
import { defaultI18nPt } from './global.pt';

export const defaultI18n = {
	en: defaultI18nEn,
	pt: defaultI18nPt,
};
